<template>
  <span>
    <widget-common-props :field="field" @changeProp="changeProp" />

    <b-form-group label-cols="3" label="Widgets">
      <f-child-fields
        :fields="field.fields"
        @change="on_changed_fields"
        @select="on_select"
      />
    </b-form-group>
  </span>
</template>

<script>
import WidgetCommonProps from "../WidgetCommonProps.vue";
import WidgetPropMixin from "../WidgetPropMixin.js";
import FChildFields from "../FChildFields.vue";

export default {
  name: "WizardStepProps",
  components: { FChildFields, WidgetCommonProps },
  mixins: [WidgetPropMixin],
};
</script>
